import React, { useContext, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";
import { ContestantsContext } from "../../../App";
import BaseLayout from "../../Layouts/BaseLayout";
import { Item } from "../../UI/Item";
import { ItemRank } from "../../UI/ItemRank";
import { Styles } from "./Styles";
// import BaseLayout from "../../Layouts/BaseLayout";
import ActivityList from "../../Partials/ActivityList";
import { loader, STable, Title } from "../Contestant/Contestant";
import { OtherCategory } from "./OtherCategory";
import { musics, sports } from "../../Layouts/Header";

export default function Rank(props) {
  const title =
    props.lang === "en"
      ? "Rank - Poinsettia Festival English"
      : "Bảng xếp hạng - Giải thưởng cống hiến 2023";

  const { table } = useParams();

  const { contestants } = useContext(ContestantsContext);

  const rank = (table && contestants && contestants[`rank${table}`]) || [];

  const [loading, setLoading] = useState(false);

  const voteList = Array(6).fill({
    _id: "0906888dfgldkfjg",
    voterId: "01d144b1018667b5b852",
    createdAt: "2022-12-28 07:44:23",
    voteId: "voteIdlksdjf342",
  });

  const rankName =
    musics.concat(sports).find((s) => s.href == window.location.pathname)
      ?.label || "";

  let isPre = true;

  let rankCheck = 0;

  rank.forEach((e) => {
    if (e.totalPoint > 0) {
      rankCheck += 1;
    }
  });

  if (rankCheck >= 3) {
    isPre = false;
  }

  return (
    <BaseLayout
      title={title}
      description={title}
      setLang={props.setLang}
      isResult
    >
      <Styles>
        <main id="main" class="main-result">
          <section className="section-result">
            <div className="bs-container">
              <div
                className="title"
                style={{ marginBottom: isPre ? 0 : "100px" }}
              >
                <h4>{isPre ? "DANH SÁCH ĐỀ CỬ" : "BẢNG XẾP HẠNG BÌNH CHỌN"}</h4>
                <h6>{rankName}</h6>
              </div>
              {!isPre && (
                <div className="top-rank">
                  {!loading && (
                    <ItemRank
                      className="top-2"
                      table={table}
                      rank={2}
                      miss={rank[1]}
                    />
                  )}
                  {!loading && (
                    <ItemRank
                      className="top-1"
                      table={table}
                      rank={1}
                      miss={rank[0]}
                    />
                  )}
                  {!loading && (
                    <ItemRank
                      className="top-3"
                      table={table}
                      rank={3}
                      miss={rank[2]}
                    />
                  )}
                </div>
              )}
              <div
                className="rest-rank"
                style={{ marginTop: isPre ? 0 : "40px" }}
              >
                {rank.slice(isPre ? 0 : 3).map((item, index) => {
                  return (
                    <Item
                      miss={item}
                      table={table}
                      rank={isPre ? index + 1 : index + 4}
                      isPre={isPre}
                    />
                  );
                })}
              </div>

              <div className="activity">
                <Title>
                  <FormattedMessage id="contestant.activity" />
                </Title>

                <STable>
                  <InfiniteScroll
                    dataLength={voteList.length}
                    // next={this.loadMore}
                    scrollThreshold={0.9}
                    // hasMore={this.state.hasMoreItems}
                    loader={loader}
                    endMessage={
                      <p style={{ textAlign: "center" }}>
                        <b>
                          <FormattedMessage id="none" />
                        </b>
                      </p>
                    }
                  >
                    <table>
                      <thead>
                        <tr>
                          <th>Đề cử được bình chọn</th>
                          <th>Sao ⭐️</th>
                          <th>Mã bình chọn</th>
                          <th>Người bình chọn</th>
                          <th>Thời gian</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ActivityList key={table} table={table} />
                      </tbody>
                    </table>
                  </InfiniteScroll>
                </STable>
              </div>
            </div>
          </section>
        </main>
      </Styles>
      <OtherCategory />
    </BaseLayout>
  );
}
